<template>
  <div class="main">
    <loading
      :show="isLoading"
      label="加载中"
    />
    <div class="main-c">
      <div class="top">
        <div class="classify">
          {{ getIntroTypeName(typeID) }}
          <!-- <span class="slant">\</span>
          <span class="news"> {{ getIntroTypeName(typeID) }} </span> -->
        </div>
        <div class="crumbs">
          您的位置：>
          <router-link to="/">
            官网首页
          </router-link>
          <span class="sep">></span><router-link :to="{path:'/intro/list',query: {typeID: typeID}}">
            {{ getIntroTypeName(typeID) }}
          </router-link>
          <span class="sep">></span>详情
        </div>
      </div>
      <div class="article">
        <h1 class="tit">
          {{ item.title }}
        </h1>
        <!-- <div class="mod-info">
          <span class="author">{{ item.adminUserName }}</span>发布于
          <span class="data">{{ item.createTime | dateformat('MM/DD') }}</span>
        </div> -->
        <div
          class="mod-article"
          v-html="item.body"
        />
      </div>
    </div>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import { getIntroTypeName } from '../../utils/utils'

export default {
  components: {
    loading
  },
  data () {
    return {
      typeID: parseInt(this.$route.query.tid) || 1,
      id: parseInt(this.$route.query.id) || 0,
      item: {},
      isLoading: true
    }
  },
  created () {
    this.getContent()
  },
  methods: {

    getContent () {
      console.log(this.id + ' ' + this.typeID)
      this.isLoading = true
      this.$api.getIntroContent({ id: this.id }).then(res => {
        this.item = res.data.item
      })
    },
    getIntroTypeName
  }
}
</script>



// WEBPACK FOOTER //
// src/components/intro/Content.vue